import React from 'react';
import { Phone, Sparkles, MessageCircle, Calendar } from 'lucide-react';
import { companyInfo } from '../../data/companyInfo';

interface MobileBottomBarProps {
  onOpenConsultation: () => void;
  onStartProject: () => void;
}

export const MobileBottomBar: React.FC<MobileBottomBarProps> = ({
  onOpenConsultation,
  onStartProject,
}) => {
  return (
    <aside 
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-[#071426]/95 backdrop-blur-xl border-t border-[#1b2f4a] px-3.5 pt-2 pb-safe shadow-[0_-8px_30px_rgba(0,0,0,0.6)] animate-fade-in"
      aria-label="Mobile Quick Action Bar"
    >
      <div className="max-w-md mx-auto flex items-center gap-2.5">
        
        {/* Quick Call / WhatsApp */}
        <a
          href={`tel:${companyInfo.contact.phone}`}
          className="flex-1 py-2.5 px-3 rounded-xl bg-[#0c1a2d] border border-[#1b2f4a] hover:border-[#159DE8] active:scale-[0.98] transition-all flex items-center justify-center gap-2 text-white font-semibold text-xs shadow-sm"
          aria-label="Call EBON Media Solutions directly"
        >
          <span className="w-2 h-2 rounded-full bg-[#00C853] animate-pulse shrink-0" />
          <Phone size={14} className="text-[#159DE8] shrink-0" />
          <span className="truncate">Call Now</span>
        </a>

        {/* Start Project CTA */}
        <button
          onClick={onStartProject}
          className="flex-[1.4] py-2.5 px-3 rounded-xl bg-gradient-to-r from-[#FF5A36] to-[#FF851B] text-white font-bold text-xs shadow-glow-orange active:scale-[0.98] transition-all flex items-center justify-center gap-1.5"
          aria-label="Start Your Project Brief"
        >
          <Sparkles size={14} className="shrink-0" />
          <span className="truncate">Start Project</span>
        </button>

      </div>
    </aside>
  );
};
